import { useMutation } from 'react-query';

import { setBaseLineDateOption as mutationFn } from 'api/endPoints/setBaseLineDateOption';

type BaseLineDateOption = {
    projectId: number | undefined;
    option?: string;
};

export const useMutationSetBaseLineDateOption = () => {
    return useMutation<unknown, QueryError, BaseLineDateOption>((params: BaseLineDateOption) => mutationFn(params));
};
